type Props = {
  onSwitchToLogin: () => void
}

export function RegisterSuccess({ onSwitchToLogin }: Props) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <p className="text-center text-sm sm:text-base">Thank you for registering!</p>
        <p className="text-center text-sm sm:text-base">
          Please check your email and verify your account before logging in.
        </p>
      </div>

      <p className="text-muted-foreground mt-2 text-center text-xs">
        Back to{' '}
        <a
          className="text-primary cursor-pointer underline"
          onClick={(e) => {
            e.preventDefault()
            onSwitchToLogin()
          }}>
          Login
        </a>
        .
      </p>
    </div>
  )
}
